<div class="radar" role="img" [attr.aria-label]="ariaLabel">
  <div
    class="radar-canvas"
    echarts
    [options]="options"
    [autoResize]="false"
    (chartInit)="onChartInit($event)"
    theme="alphabees"
    aria-hidden="true"
  ></div>
</div>
